import { StyleSheet } from 'aphrodite';
import {
	background,
	brandSecondary,
	error,
	grayIconFill,
	midGray,
	titles,
	warningDark,
	white,
} from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: 600,
		maxWidth: 650,
		maxHeight: '90vh',
		background: white,
	},
	body: {
		flex: 1,
		overflow: 'auto',
		minHeight: 0,
		paddingBottom: 0,
	},
	bodyText: {
		color: titles,
		marginBottom: 20,
	},
	closeButton: {
		marginLeft: 10,
		fontSize: 14,
		padding: '6px 12px',
	},
	buttonsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		padding: '20px 0 0 0',
		borderTop: `1px solid ${midGray}`,
		background: white,
		marginTop: 'auto',
	},
	buttonGroup: {
		display: 'flex',
		flexDirection: 'row',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},

	modal: {
		...CssSelectors.allChildren(
			{
				'@media only screen and (max-height: 768px)': {
					alignItems: 'flex-start',
				},
				alignItems: 'center',
			},
			'.modal-overlay'
		),
	},
	text: {
		fontSize: 14,
		lineHeight: '18px',
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		lineHeight: '22px',
		marginBottom: 16,
	},
	fileInputContainer: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 15,
	},
	fileInput: {
		flex: 1,
	},
	testRunButton: {
		marginLeft: 10,
		fontSize: 14,
		padding: '6px 12px',
	},
	testResults: {
		marginTop: 15,
		padding: 10,
		backgroundColor: white,
		border: `1px solid ${midGray}`,
		borderRadius: 4,
	},
	testResultsTitle: {
		fontSize: 16,
		marginBottom: 10,
	},
	testError: {
		color: error,
	},
	testWarning: {
		color: warningDark,
	},
	testResultsJson: {
		whiteSpace: 'pre-wrap',
		backgroundColor: background,
		padding: 10,
		borderRadius: 4,
		fontSize: 12,
		lineHeight: '18px',
		maxHeight: 300,
		overflowY: 'auto',
	},
	formattedResults: {
		marginTop: 15,
	},
	leadResultCard: {
		backgroundColor: background,
		borderRadius: 4,
		padding: 15,
		marginBottom: 15,
		boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
	},
	resultSection: {
		marginBottom: 15,
		padding: 10,
		backgroundColor: white,
		borderRadius: 4,
		border: `1px solid ${midGray}`,
	},
	resultSectionTitle: {
		fontSize: 14,
		fontWeight: 600,
		marginBottom: 8,
		color: titles,
	},
	tagBadge: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 8,
	},
	tag: {
		display: 'inline-block',
		backgroundColor: brandSecondary,
		color: white,
		borderRadius: 20,
		padding: '4px 12px',
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.2,
	},
	contactDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	contactField: {
		display: 'flex',
		fontSize: 13,
	},
	fieldLabel: {
		fontWeight: 600,
		width: 100,
		color: titles,
		flexShrink: 0,
	},
	fieldValue: {
		flex: 1,
		wordBreak: 'break-word',
	},
	addressLines: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
	},
	simulationCaveat: {
		marginTop: 8,
		fontSize: 12,
		fontStyle: 'italic',
		color: grayIconFill,
		lineHeight: '16px',
	},
	noteContent: {
		fontSize: 13,
		lineHeight: '1.5',
		whiteSpace: 'pre-wrap',
	},
	richContentContainer: {
		maxWidth: '100%',
		overflow: 'hidden',
		'& img': {
			maxWidth: '100%',
		},
		'& a': {
			color: brandSecondary,
			textDecoration: 'underline',
		},
		'& p': {
			margin: '0 0 10px 0',
		},
	},
});
